module.exports = __webpack_public_path__ + "static/media/logo.8f33f088.svg";